<template>
    <div class="broadcast-sended-details">
        <div class="broadcast-sended-details-title">Gönderim Durumları</div>
        <div class="broadcast-sended-details-header">
            <div class="broadcast-sended-details-stats">
                <div class="stat-box success">
                    <div class="stat-label">Başarılı</div>
                    <div class="stat-value">{{ successCount }}</div>
                </div>
                <div class="stat-box failure">
                    <div class="stat-label">Başarısız</div>
                    <div class="stat-value">{{ failureCount }}</div>
                </div>
                <div class="stat-box enqueued">
                    <div class="stat-label">İşlemde</div>
                    <div class="stat-value">{{ enqueuedCount }}</div>
                </div>
            </div>
            <div class="broadcast-sended-details-filters">
                <a-form-item label="Durum">
                    <a-select v-model="statusFilter">
                        <a-select-option value="all">Tümü</a-select-option>
                        <a-select-option value="enqueued">Gönderimde</a-select-option>
                        <a-select-option value="sent">Gönderildi</a-select-option>
                        <a-select-option value="delivered">Teslim Edildi</a-select-option>
                        <a-select-option value="read">Okundu</a-select-option>
                        <a-select-option value="failed">Başarısız</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="Hata Mesajı">
                    <a-select v-model="failureReasonFilter">
                        <a-select-option value="all">Tüm Hatalar</a-select-option>
                        <a-select-option v-for="reason in distinctFailureReasons" :value="reason" :key="reason"
                            >{{ reason }}
                        </a-select-option>
                    </a-select>
                </a-form-item>
            </div>
        </div>
        <div class="broadcast-sended-details-download">
            <SupsisButton ghost @click="downloadCSV">
                <a-icon type="download" />
                CSV İndir
            </SupsisButton>
            <SupsisButton ghost @click="downloadExcel">
                <a-icon type="file-excel" />
                Excel İndir
            </SupsisButton>
        </div>
        <div class="broadcast-sended-details-table">
            <SupsisTable :columns="cols" :rows="filteredDetails" />
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import { mapState } from "vuex";
import SupsisTable from "../../../../../components/SupsisTable.vue";
import SupsisButton from "../../../Settings/components/SupsisButton.vue";
import { expertToExcel, exportToCSV } from "../../../../../utils/utils";

export default Vue.extend({
    name: "BroadcastSendedDetails",
    components: { SupsisButton, SupsisTable },
    props: {
        details: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        const status = {
            enqueued: "Gönderimde",
            sent: "Gönderildi",
            delivered: "Teslim Edildi",
            read: "Okundu",
            failed: "Başarısız",
        };
        return {
            cols: [
                {
                    field: "number",
                    key: "number",
                    title: "Telefon Numarası",
                    width: 50,
                    align: "left",
                    renderBodyCell: ({ row }) => {
                        return <div>{row.number}</div>;
                    },
                },
                {
                    key: "success",
                    field: "success",
                    title: "Durum",
                    width: 50,
                    align: "left",
                    renderBodyCell: ({ row }) => {
                        return <div>{status[row.status] || status.enqueued}</div>;
                    },
                },
                {
                    key: "failureReason",
                    field: "failureReason",
                    title: "Hata Mesajı",
                    width: 50,
                    align: "left",
                    renderBodyCell: ({ row }) => {
                        return <div>{row.failureReason || "N/A"}</div>;
                    },
                },
            ],
            statusFilter: "all",
            failureReasonFilter: "all",
            status,
        };
    },
    computed: {
        ...mapState({
            siteId: (state) => state.site.site._id,
            user: (state) => state.auth.user,
        }),
        successCount() {
            return this.details.filter((detail) => ["sent", "delivered", "read"].includes(detail.status)).length;
        },
        failureCount() {
            return this.details.filter((detail) => detail.status === "failed").length;
        },
        enqueuedCount() {
            return this.details.filter((detail) => detail.status === "enqueued").length;
        },
        distinctFailureReasons() {
            return [...new Set(this.details.map((detail) => detail.failureReason).filter(Boolean))];
        },
        filteredDetails() {
            return this.details.filter((detail) => {
                const statusMatch = this.statusFilter === "all" || detail.status === this.statusFilter;
                const reasonMatch =
                    this.failureReasonFilter === "all" || detail.failureReason === this.failureReasonFilter;

                return statusMatch && reasonMatch;
            });
        },
    },
    methods: {
        downloadCSV() {
            const csvData = this.filteredDetails.map((detail) => ({
                number: detail.number,
                status: this.status[detail.status] || this.status.enqueued,
                failureReason: detail.failureReason || "N/A",
            }));
            exportToCSV(csvData, "broadcast_details.csv");
        },
        downloadExcel() {
            const excelData = this.filteredDetails.map((detail) => ({
                number: detail.number,
                status: this.status[detail.status] || this.status.enqueued,
                failureReason: detail.failureReason || "N/A",
            }));
            expertToExcel(excelData, "broadcast_details.xlsx", "Broadcast Details");
        },
    },
});
</script>

<style scoped lang="scss">
.broadcast-sended-details {
    display: flex;
    width: 100%;
    flex-direction: column;
    height: 100%;
    gap: 10px;

    &-title {
        font-size: 18px;
        font-weight: bold;
    }

    &-table {
        height: 70vh;
        overflow-y: auto;
        overflow-x: hidden;
    }

    &-stats {
        display: flex;
        gap: 20px;
        font-size: 16px;

        .stat-box {
            padding: 5px 10px;
            border-radius: 4px;

            &.success {
                background-color: #f6ffed;
                border: 1px solid #b7eb8f;
            }

            &.failure {
                background-color: #fff2f0;
                border: 1px solid #ffccc7;
            }

            &.enqueued {
                background-color: #e6f7ff;
                border: 1px solid #91d5ff;
            }
        }

        .stat-label {
            font-weight: bold;
        }

        .stat-value {
            text-align: center;
            font-size: 24px;
        }
    }

    &-filters {
        display: flex;
        gap: 10px;
        margin-bottom: 10px;
    }

    &-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
    }

    &-download {
        display: flex;
        justify-content: flex-end;
        gap: 10px;
        margin-bottom: 10px;
    }
}
</style>
